import type { LeagueCard } from "@core/league/types";
import { atom } from "@mongez/react-atom";

/**
 * The after-activity League card currently on screen. Written only from
 * client event handlers (a reward response), never during SSR or in a
 * loader, so it holds no per-request state on the server.
 */
export type LeagueCardNotice = {
  /** Increments per publish so an identical card still re-triggers the host. */
  id: number;
  card: LeagueCard;
};

export const leagueCardAtom = atom<LeagueCardNotice | null>({
  key: "leagueCardNotice",
  default: null,
});

/** Show a merged League card (client only). */
export function publishLeagueCard(card: LeagueCard): void {
  leagueCardAtom.update({ id: (leagueCardAtom.value?.id ?? 0) + 1, card });
}

export function dismissLeagueCard(): void {
  leagueCardAtom.update(null);
}
